import { defineComponent, h } from 'vue';
import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
import { t } from '@/ui/i18n/i18n';

interface RemoveLabelConfirmationModalProps {
  active: boolean;
  loading: boolean;
}

export const RemoveLabelConfirmationModal = defineComponent<RemoveLabelConfirmationModalProps>({
  name: 'RemoveLabelConfirmationModal',
  props: ['active', 'loading'],
  setup(props, context) {
    const onCancelClick = () => {
      context.emit('input', false);
    };

    const onConfirmation = () => {
      context.emit('click:removeLabel');
    };

    return function render() {
      return h(ConfirmationModal, {
        class: 'remove-label-confirmation-modal',
        props: {
          width: '580px',
          active: props.active,
          confirmText: t('common.delete'),
          declineText: t('common.cancel'),
          confirmationButtonProps: { type: 'is-danger', loading: props.loading },
        },
        on: {
          declined: onCancelClick,
          accepted: onConfirmation,
        },
      }, [
        h('h1', { class: 'entity-folder-label-confirmation-modal__title title' }, t('entity-folder.remove-label.title')),
        h('div', t('entity-folder.remove-label.content')),
      ]);
    };
  },
});
